import { add, qsa, remove } from "@fluorescent/dom";

const cn = "full-width";

export default () => {
  function adjustClasses() {
    const sections = qsa(".shopify-section");
    sections.forEach(s => {
      const { firstElementChild: child } = s;
      if (child && child.classList.contains(cn)) {
        remove(child, cn);
        add(s, cn);
      }
    });
  }

  adjustClasses();
  document.addEventListener("shopify:section:load", adjustClasses);
};
